import React from 'react';
import moment from 'moment';
import { makeStyles, withStyles, Table, Divider, Typography, Grid } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from '../LeaveApplication/component/RecentLeave/Title';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({

    content: {
        fontSize: 12,
    },
    circularProgressbar: {
        maxWidth: 120
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    depositContext: {
        flex: 1,
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(1),
    },
    header: {
        fontSize: 12,
        fontWeight: 600
    },
    dateWidth: {
        minWidth: 95,
    },
    miniTableContainer: {
        maxHeight: 315,
    },
    miniTableTitle: {
        display: 'flex',
        justifyContent:'space-between',
        alignItems: 'center',
    },
    mainTitle: {
        maxWidth: 220,
    },
    subTitle: {
        fontWeight: 600,
    }
}));

const StyledDivider = withStyles({
    root: {
        background: '#DCDCDC',
        height: 2,
    },
})(Divider);

export default function MiniTable({ rows, staffDuty }) {
    const classes = useStyles();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [totalRemaining, setTotalRemaining] = React.useState();
    const [hasCashOut, setHasCashOut] = React.useState(false);
    const isFMDepartment = localStorage.getItem('department_id') == 3;
    const isShiftDuty = (localStorage.getItem('staff_duty') === window.global.shiftDuty) ||
                        (staffDuty != null && staffDuty == window.global.shiftDuty);

    // React.useEffect(() => {
    //     if (rows !== undefined) {
    //         setShowCompetent(true)
    //     }
    // }, [rows]);

    React.useEffect(() => {
        if (rows !== undefined) {
            setShowCompetent(true)
        }

        calculateTotalHours(rows);

        const hasCashOut = rows.some(item => {
            const cashOutValue = parseFloat(item.cashOut);
            return !isNaN(cashOutValue) && cashOutValue > 0;
        });
        setHasCashOut(hasCashOut);
    }, [rows]);

    function calculateTotalHours(rows) {
        let totalHours = 0;
        rows.forEach((row) => {
            totalHours += Number(row.remaining) || 0;
        });

        setTotalRemaining(totalHours);
    }

    return (
        <React.Fragment>
            {showCompetent ? (
                <div
                    className={`${classes.root} ${classes.miniTableContainer}`}
                >
                    <Grid className={classes.miniTableTitle}>
                        <Typography
                            className={classes.mainTitle}
                            component='h2'
                            variant='h6'
                            color='primary'
                            gutterBottom
                        >
                            <FormattedMessage id='comp_leave.endorsed_balance' />
                        </Typography>
                        <Typography className={classes.subTitle}>
                            {isShiftDuty ? (
                                <FormattedMessage id='cash_out.pending_cash_out' />
                            ) : (
                                <FormattedMessage id='comp_leave.total_remaining' />
                            )}
                            : {totalRemaining}
                            {' '}<FormattedMessage id='comp_leave.hrs' />
                        </Typography>
                    </Grid>
                    <StyledDivider />
                    <TableContainer>
                        <Table aria-label='recent-leaves-table'>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        className={`${classes.header} ${classes.dateWidth}`}
                                    >
                                        <FormattedMessage id='comp_leave.duty_date' />
                                    </TableCell>
                                    {!isShiftDuty && (
                                        <TableCell
                                            className={`${classes.header} ${classes.dateWidth}`}
                                    >
                                            <FormattedMessage id='comp_leave.expiry_date' />
                                        </TableCell>
                                    )}
                                    <TableCell
                                        className={classes.header}
                                        align='left'
                                    >
                                        <FormattedMessage id='comp_leave.earn' />
                                    </TableCell>
                                    {!isShiftDuty && (
                                        <TableCell
                                            className={classes.header}
                                        align='left'
                                    >
                                            <FormattedMessage id='comp_leave.used' />
                                        </TableCell>
                                    )}
                                    {(hasCashOut || isShiftDuty) ? (
                                        <TableCell
                                            className={classes.header}
                                            align='left'
                                        >
                                            <FormattedMessage id='cash_out.cashed_out' />
                                        </TableCell>
                                    ) : null}
                                    <TableCell
                                        className={classes.header}
                                        align='left'
                                    >
                                        <FormattedMessage id='comp_leave.remaining' />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.length > 0 ? (
                                    rows?.slice(0, 10).map((row, i) => (
                                        <TableRow key={row.id || i}>
                                            <TableCell
                                                align='left'
                                                className={classes.content}
                                            >
                                                {row.dataSubmitted}{' '}
                                            </TableCell>
                                            {!isShiftDuty && (
                                                <TableCell
                                                    align='left'
                                                    className={classes.content}
                                                >
                                                    {row.expiryDate}{' '}
                                                </TableCell>
                                            )}
                                            <TableCell
                                                align='left'
                                                className={classes.content}
                                            >
                                                {row.earn}{' '}
                                            </TableCell>
                                            {!isShiftDuty && (
                                                <TableCell
                                                    align='left'
                                                    className={classes.content}
                                                >
                                                    {row.used}{' '}
                                                </TableCell>
                                            )}
                                            {(hasCashOut || isShiftDuty) ? (
                                                <TableCell
                                                    align='left'
                                                    className={classes.content}
                                                >
                                                    {row.cashOut}{' '}
                                                </TableCell>
                                            ) : null}
                                            <TableCell
                                                align='left'
                                                className={classes.content}
                                            >
                                                {row.remaining}{' '}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow align='center' width={'100%'}>
                                        <TableCell colSpan={5} align='center'>
                                            <FormattedMessage id='table.no_match' />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            ) : (
                <div className={classes.circularProgress}>
                    <CircularProgress />
                </div>
            )}
        </React.Fragment>
    );
}